import { Button } from "@msuite/ui/button";
import { useLoading } from "@msuite/ui/hooks";
import { Icon } from "@msuite/ui/icons";
import { useTranslation } from "@msuite/ui/localization";
import { useDataTableContext } from "@msuite/ui/table";
import { responseHandler } from "@msuite/ui/utils";
import React from "react";
import { client } from "@/hono";
import { useAutoIntegrationContext } from "./context";

/** Props Interface */
interface AutoIntegrationMenuProps {
	integrationType: "webfleet";
	onComplete: () => Promise<unknown>;
}

export function AutoIntegrationMenu({ integrationType, onComplete }: AutoIntegrationMenuProps) {
	/** Context */
	const { refetch, hasRowSelection, rowSelection, getSelectedRowIds } = useDataTableContext();
	const { autoIntegrationList } = useAutoIntegrationContext();

	/** Hooks */
	const { t } = useTranslation();
	const loader = useLoading();

	/** Guard */
	if (!hasRowSelection) return null;

	/** Computed */
	const selectedCount = Object.keys(rowSelection).length;

	/** Functions */
	async function handleOnAutoIntegration() {
		try {
			loader.start();
			const response = await client.integrations[integrationType]["auto-integration"].$post({
				json: {
					list: autoIntegrationList as any,
					selection: getSelectedRowIds(),
				},
			});
			await responseHandler(response);
			await refetch?.();
			await onComplete();
		} catch (error) {
			console.error(error);
		} finally {
			loader.stop();
		}
	}

	/** Render */
	return (
		<React.Fragment>
			<Button
				variant="primary"
				icon={<Icon name="FolderSync" />}
				onClick={handleOnAutoIntegration}
				isLoading={loader.isLoading}
			>
				{t(`integrations.synchronize_n_with_${integrationType}`, {
					count: selectedCount.toString(),
				})}
			</Button>
		</React.Fragment>
	);
}
